<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            <div>Nastavení komunikace</div>
        </div>
    </div>

    <div class="hypo-dialog-content" [attr.data-testid]="'comm-dialog'">
        <p>Níže zvolte, jakým způsobem s vámi můžeme komunikovat a jaké informace od nás chcete dostávat.</p>
        @if (preferencesForm) {
            <form class="preferences-form" [formGroup]="preferencesForm" [class.loading-shine]="loading">
                <div class="preference">
                    <mat-icon>mobile_friendly</mat-icon>
                    <div class="comm-type">SMS</div>
                    <div class="label">Nezbytné systémové zprávy (povinné)</div>
                    <div class="hint">
                        Systémové zprávy nezbytné pro použití hypotečního bankovnictví sloužící např. k ověření kódem.
                    </div>
                    <mat-slide-toggle
                        formControlName="disabledSystemMsg"
                        [attr.data-testid]="'comm-dialog-disabled-system-sms'">
                    </mat-slide-toggle>
                </div>
                <div class="preference">
                    <mat-icon>mail_outline</mat-icon>
                    <div class="comm-type">Email</div>
                    <div class="label">Nezbytné systémové zprávy (povinné)</div>
                    <div class="hint">
                        Systémové zprávy nezbytné pro použití hypotečního bankovnictví sloužící např. k ověření kódem.
                    </div>
                    <mat-slide-toggle
                        formControlName="disabledSystemMsg"
                        [attr.data-testid]="'comm-dialog-disabled-system-email'">
                    </mat-slide-toggle>
                </div>
                <div class="preference">
                    <mat-icon>mobile_friendly</mat-icon>
                    <div class="comm-type">SMS</div>
                    <div class="label">Pozastavené případy</div>
                    <div class="hint">
                        Informace v souvislosti s případy, které jste u nás v minulosti řešili, ale momentálně jsou
                        pozastaveny.
                    </div>
                    <mat-slide-toggle
                        formControlName="disabledCasesSms"
                        [attr.data-testid]="'comm-dialog-disabled-cases-sms'">
                    </mat-slide-toggle>
                </div>
                <div class="preference">
                    <mat-icon>mail_outline</mat-icon>
                    <div class="comm-type">Email</div>
                    <div class="label">Pozastavené případy</div>
                    <div class="hint">
                        Informace v souvislosti s případy, které jste u nás v minulosti řešili, ale momentálně jsou
                        pozastaveny.
                    </div>
                    <mat-slide-toggle
                        formControlName="disabledCasesEmail"
                        [attr.data-testid]="'comm-dialog-disabled-cases-email'">
                    </mat-slide-toggle>
                </div>
                <div class="preference">
                    <mat-icon>mobile_friendly</mat-icon>
                    <div class="comm-type">SMS</div>
                    <div class="label">Marketingová komunikace</div>
                    <div class="hint">Informace o aktuálních novinkách a nabídkách na hypotečním trhu.</div>
                    <mat-slide-toggle
                        formControlName="disabledMarketingSms"
                        [attr.data-testid]="'comm-dialog-disabled-marketing-sms'">
                    </mat-slide-toggle>
                </div>
                <div class="preference">
                    <mat-icon>mail_outline</mat-icon>
                    <div class="comm-type">Email</div>
                    <div class="label">Marketingová komunikace</div>
                    <div class="hint">Informace o aktuálních novinkách a nabídkách na hypotečním trhu.</div>
                    <mat-slide-toggle
                        formControlName="disabledMarketingEmail"
                        [attr.data-testid]="'comm-dialog-disabled-marketing-email'">
                    </mat-slide-toggle>
                </div>
            </form>
        }

        <div class="hypo-dialog-footer flex flex-row items-center justify-center">
            <button
                (click)="saveAndClose()"
                class="btn btn-lg orange info-text-dialog-button"
                mat-button
                [attr.data-testid]="'comm-dialog-button-save'"
                type="button">
                Zavřít
            </button>
        </div>
    </div>
</mat-dialog-content>
